<template>
  <transition name="search-overlay">
    <div
      ref="overlayElement"
      class="search-overlay"
      v-show="state.isOpen"
      @keydown.esc="toggle"
      :id="state.overlayId"
    >
      <div class="spacer-horizontal">
        <slot />
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed, ref, watch, nextTick } from 'vue';
import { uuid } from 'vue-uuid';
import { useSharedState } from '@composables/use-shared-state';

const id = ref(uuid.v1());
const { state } = useSharedState({ id: 'search-overlay' });
const { state: overlay } = useSharedState({ id: 'overlay' });

state.isOpen = false;
state.overlayId = `search-overlay-${id.value}`;

const isOpen = computed(() => state.isOpen);

const toggle = () => {
  state.isOpen = !state.isOpen;
};

watch(isOpen, isOpen => {
  overlay.isVisible = isOpen;
});

const isOverlayVisible = computed(() => overlay.isVisible);

watch(isOverlayVisible, isOverlayVisible => {
  state.isOpen = isOverlayVisible;
});

const overlayElement = ref(undefined);
const setInitialFocus = () => {
  if (!overlayElement.value) return;

  const initialFocusTarget = overlayElement.value.querySelector('input');
  initialFocusTarget?.focus();
};

watch(isOpen, isOpen => {
  if (!isOpen) return;

  nextTick(setInitialFocus);
});
</script>
